module.exports = __webpack_public_path__ + "img/tsering-pemba-_ccJa73HR2I-unsplash.5cc85f5e.jpg";